var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.needInitI18n)?_c('init-i18n'):_c('router-view'),_c('portal-target',{attrs:{"name":"vue-body-dialog"}}),(_vm.showEnvPicker)?_c('env-picker'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }